import { takeLatest, call, put } from 'redux-saga/effects'
import listActiveParticipants from 'api/administration/participants/ListActiveParticipants'
import * as fromActions from '../../actions/user.action'

interface ListParams {
  page?: number
  searchText?: string
  sort?: any[]
  usersFilter?: string
  perPage?: number
  fastFilters?: number
}

function getList({
  page = 1,
  searchText,
  sort,
  usersFilter,
  perPage = 50,
  fastFilters,
}: ListParams) {
  return listActiveParticipants({
    page,
    area: [],
    searchText,
    sort,
    usersFilter,
    perPage,
    fastFilters,
  })
}

function* participantsListEffectSaga(action: fromActions.SearchAction) {
  try {
    const {
      page,
      searchText,
      sort,
      usersFilter,
      perPage: itemsPerPage,
      fastFilters,
    } = action.payload

    const { data, total, perPage } = yield call(getList, {
      page,
      searchText,
      sort,
      usersFilter,
      fastFilters,
      perPage: itemsPerPage,
    })
    yield put(fromActions.Actions.searchSuccess({ data, total, perPage }))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* searchUserListWatcherSaga() {
  yield takeLatest(fromActions.SEARCH_USER_LIST, participantsListEffectSaga)
}
